import { Navigate } from "react-router";
import { useSearchParams } from "react-router-dom";
import { useAuth } from "../../auth";
import { ROUTES } from "../../routes";

export const SSOComplete = () => {
    // The session check is fired by useAuth() on mount. Landing here means the
    // SSO provider has just handed us a session cookie.
    const { loggedIn, error } = useAuth();

    // Redirect to dashboard if logged in
    const [searchParams] = useSearchParams();
    const nextParam = searchParams.get("next");
    if (loggedIn) {
        let nextPage = ROUTES.ROOT;
        if (nextParam) {
            nextPage = nextParam;
        }
        return <Navigate to={nextPage} />;
    }

    // A failed check (401, 5xx or a dropped connection) sends them back to the
    // login page, keeping ?next=. The API client middleware leaves session
    // check 401s to us. Without this the page sits on <noscript /> forever.
    if (error) {
        const query = nextParam
            ? `?${new URLSearchParams({ next: nextParam })}`
            : "";
        return <Navigate to={`${ROUTES.LOGIN}${query}`} />;
    }

    return <noscript />;
};
